<div>
  <h1 mat-dialog-title class="p-3 mb-0 fs-30">
    <ng-container *ngIf="data?.title; else customTitleTmpl">{{ data.title }}</ng-container>

    <ng-template #customTitleTmpl>
      <ng-container *ngIf="data.reset">
        Are you sure you want to reset <strong>{{ name }}'s</strong> care plan?
      </ng-container>
      <ng-container *ngIf="!data.reset">
        Are you sure you want to delete <strong>{{ name }}</strong> patient?
      </ng-container>
    </ng-template>
  </h1>

  <div mat-dialog-content></div>

  <div mat-dialog-actions>
    <div class="button_container mr-3">
      <button mat-button (click)="onNoClick()" class="back_btn">No</button>
    </div>
    <div class="button_container">
      <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="next_btn">
        <ng-container *ngIf="data?.okTitle; else customYesTmpl">{{ data.okTitle }}</ng-container>

        <ng-template #customYesTmpl>
          <ng-container *ngIf="data.reset == false">Yes, Delete Account</ng-container>
          <ng-container *ngIf="data.reset == true">Yes, Reset Care Plan</ng-container>
        </ng-template>
      </button>
    </div>
  </div>
</div>
